<template>
    <span v-if="!_.isEmpty(soap)">
        <!-- TODO : Some of the api does not has the encoded_id : To add the encoded_id to the api that use this component later-->
        <b-link
            v-if="isSoapEnableBeta && encodedId"
            :to="{ name: 'soap', params: { id: encodedId } }"
        >
            {{ text || soap.label }}
        </b-link>
        <a v-else-if="isCiFullLink" :href="soap.ci_url || '#'">
            {{ text || soap.label }}
        </a>
        <a v-else-if="soap.ci_url" :href="env.APPS + soap.ci_url || '#'">
            {{ text || soap.label }}
        </a>
        <span v-else> {{ text || soap.label }} </span>
    </span>
</template>

<script>
export default {
    name: "medicalNoteLink",
    props: {
        soap: {
            type: Object,
            required: true,
            default: () => {}
        },
        /**
         * text: label shown. if not specified, soap.text will be used
         */
        text: {
            type: String,
            default: null
        }
    },
    computed: {
        encodedId() {
            return this.soap.encoded_id;
        },
        isSoapEnableBeta() {
            return this.$store.getters["soap/isSoapEnableBeta"];
        },
        isCiFullLink() {
            return (
                this.soap.ci_url &&
                this.soap.ci_url.includes(location.origin + this.env.APPS)
            );
        }
    }
};
</script>
